export const HeaderLabelsLegacy = {
  DEFAULT: ['label:NHG', 'label:65%', 'label:85%', 'label:moreThan85%'],
  overwaarde: ['label:lumpsum', 'label:monthly'],
  duurzaam: ['label:interest'],
  startzeker: ['label:NHG']
};

export const HeaderLabels = {
  DEFAULT: ['label:NHG', 'label:65%', 'label:85%', 'label:90%', 'label:moreThan90%'],
  overwaarde: ['label:lumpsum', 'label:monthly'],
  duurzaam: ['label:interest'],
  startzeker: ['label:NHG']
};
